import { PUBLIC_HOSTS } from '../constant'
import type { HOSTKEY } from '../constant'
import { GetKdocsPathFn, GetFn, GetHostFn, GetPortFn, GetHostNameFn, GetSchemeFn, GetPathFn, GetOriginFn } from '../type'
const target = typeof window !== 'undefined' ? window : global

/**
 * @description 传递相关属性获取路径相对应的部分
 * @returns 
 */
export const get: GetFn = function (this: any, key: HOSTKEY | Lowercase<HOSTKEY> = 'KDOCS', attr: string) {
  let result = {}
  try {
    const addresses = (this && this.__KD_CONFIG__ && this.__KD_CONFIG__.addresses) || target.__KD_CONFIG__.addresses
    // 兼容大小写
    const item = addresses[key.toLowerCase()] || addresses[key.toUpperCase()]
    result = {
      host: item.host,
      path: item.path,
      scheme: item.scheme + ':',
      port: (Number(item.port) === 80 || Number(item.port) === 443 || !item.port) ? '' : (':' + item.port),
    }
  } catch (error) {
    result = PUBLIC_HOSTS[key.toUpperCase()] || PUBLIC_HOSTS['KDOCS']
  }
  return result[attr] || ''
}


/**
 * 获取请求协议
 * @returns 
 */
export const getScheme: GetSchemeFn = function (this: any, hostKey: HOSTKEY | Lowercase<HOSTKEY> = 'KDOCS') {
  return get.call(this, hostKey, 'scheme')
}

/**
 * @description 获取指定域名的path
 * @param {*} hostKey 
 * @param {*} ctx 
 * @returns 
 */
export const getPath: GetPathFn = function (this: any, hostKey: HOSTKEY | Lowercase<HOSTKEY> = 'KDOCS') {
  return get.call(this, hostKey, 'path')
}

/**
 * @description 获取kdcos的hostname
 * @returns 
 */
export const getHostName: GetHostNameFn = function (this: any, hostKey: HOSTKEY | Lowercase<HOSTKEY> = 'KDOCS') {
  return get.call(this, hostKey, 'host')
}


/**
 * @description 获取kdcos的port
 * @returns 
 */
export const getPort: GetPortFn = function (this: any, hostKey: HOSTKEY | Lowercase<HOSTKEY> = 'KDOCS') {
  return get.call(this, hostKey, 'port')
}

/**
 * @description 获取kdcos的path
 * @returns 
 */
export const getKdocsPath: GetKdocsPathFn = function (this: any) {
  return get.call(this, 'KDOCS', 'path')
}

/**
 * @description 获取不带协议的域名路径：host + port + path
 * @param {*} hostKey 
 * @param {*} ctx 
 * @returns 
 */
export const getHost: GetHostFn = function (this: any, hostKey: HOSTKEY | Lowercase<HOSTKEY>) {
  const hostname = getHostName.call(this, hostKey)
  const port = getPort.call(this, hostKey)
  const pathname = getPath.call(this, hostKey)
  return hostname + port + pathname
}

/**
 * @description 获取协议的域名路径：scheme + host + port + path
 * @param {*} hostKey 
 * @param {*} ctx 
 * @returns 
 */
export const getOrigin: GetOriginFn = function (this: any, hostKey: HOSTKEY | Lowercase<HOSTKEY>) {
  const protocol = getScheme.call(this, hostKey)
  return protocol + '//' + getHost.call(this, hostKey)
}

// https多了个：    多了端口号


export class ReadConstants {
  __KD_CONFIG__ = { addresses: {} }
  constructor (powerConstants) {
    this.__KD_CONFIG__.addresses = powerConstants
  }
  get = get
  getScheme = getScheme
  getHostName = getHostName
  getPort = getPort
  getPath = getPath
  getKdocsPath = getKdocsPath
  getHost = getHost
  getOrigin = getOrigin
}

// class readConstants {
//   powerConstants = {}
//   constructor(powerConstants){
//     this.powerConstants = powerConstants
//   }
//   get(hostKey: HOSTKEY, attr: string) {
//     try {
//       return this.powerConstants[hostKey || 'kdocs'][attr]
//     } catch (error) {
//       return ''
//     }
//   }
//   getScheme(hostKey: HOSTKEY) {
//     return this.get(hostKey, 'protocol')
//   }
//   getHostName(hostKey: HOSTKEY) {
//     return this.get(hostKey, 'hostname')
//   }
//   getPort(hostKey: HOSTKEY) {
//     return this.get(hostKey, 'port')
//   }
//   getPath(hostKey: HOSTKEY) {
//     return this.get(hostKey, 'pathname')
//   }
//   getKdocsPath() {
//     return this.get('KDOCS', 'path')
//   }
//   getHost(hostKey: HOSTKEY) {
//     const host = this.getHostName(hostKey)
//     const port = this.getPort(hostKey)
//     const path = this.getPath(hostKey)
//     return host + port + path
//   }
//   getOrigin(hostKey: HOSTKEY) {
//     const scheme = this.getScheme(hostKey)
//     return scheme + '//' + this.getHost(hostKey)
//   }
// }